import { useEffect, useState } from 'react';
import { deadlineLabel, formatDateTime, parseInstant } from '@/lib/dataFormat';
import { cn } from './cn';

export function Deadline({
  at,
  timeZone = 'Europe/Moscow',
  now,
  overdueTone = 'default',
}: {
  at: string | Date;
  timeZone?: string;
  now?: number;
  /** Stronger text on cards; existing consumers keep their color. */
  overdueTone?: 'default' | 'strong';
}) {
  const [tick, setTick] = useState(Date.now);
  useEffect(() => {
    if (now !== undefined) return;
    const timer = window.setInterval(() => setTick(Date.now()), 60000);
    return () => window.clearInterval(timer);
  }, [now]);
  const result = deadlineLabel(at, now ?? tick, timeZone);
  const exact = formatDateTime(at, timeZone);
  const date = parseInstant(at);
  return (
    <time
      data-slot="deadline"
      dateTime={date?.toISOString()}
      title={`${exact} · ${timeZone}`}
      className={cn(
        'text-xs',
        result.overdue
          ? overdueTone === 'strong'
            ? 'font-medium text-danger-strong'
            : 'font-medium text-danger-fg'
          : 'text-fg-muted',
      )}
    >
      {result.label}
    </time>
  );
}

export function ZonedDateTime({
  at,
  timeZone = 'Europe/Moscow',
  label,
}: {
  at: string | Date;
  timeZone?: string;
  label?: string;
}) {
  const date = parseInstant(at);
  return (
    <time
      dateTime={date?.toISOString()}
      title={timeZone}
      className="font-mono text-xs whitespace-nowrap tabular-nums"
    >
      {formatDateTime(at, timeZone)}{' '}
      <span className="font-sans text-fg-muted">
        {label ?? (timeZone === 'Europe/Moscow' ? 'МСК' : timeZone)}
      </span>
    </time>
  );
}
